import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { PageNotFoundComponent } from '../app/shared/components/page-not-found/page-not-found.component';
import { ContractCallbackComponent } from '../app/features/supplier/contract/contract-callback/contract-callback.component';

import { AuthGuardService } from '../app/core/guards/auth-guard.service';
import { LoginGuardService } from '../app/core/guards/login-guard.service';
import { PreventLandingGuardService } from '../app/core/guards/prevent-landing-guard.service';
import { WelcomeGuardService } from '../app/core/guards/welcome-guard.service';

const routes: Routes = [
  {
    path: 'business-energy',
    loadChildren: () => import('./features/business-energy/business-energy.module').then((m) => m.BusinessEnergyModule)
  },
  {
    path: 'business-energy/:refId',
    loadChildren: () => import('./features/business-energy/business-energy.module').then((m) => m.BusinessEnergyModule)
  },
  {
    path: 'supplier',
    loadChildren: () => import('./features/supplier/supplier.module').then((m) => m.SupplierModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'details',
    loadChildren: () => import('./features/details/details.module').then((m) => m.DetailsModule),
    canActivate: [AuthGuardService],
  },
  {
    path: 'rbswelcome',
    loadChildren: () => import('./features/welcome-rbs/welcome-rbs.module').then((m) => m.WelcomeRbsgModule),
    canActivate: [PreventLandingGuardService]
  },
  {
    path: 'rbswelcome/:refId',
    loadChildren: () => import('./features/welcome-rbs/welcome-rbs.module').then((m) => m.WelcomeRbsgModule),
    canActivate: [PreventLandingGuardService]
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./features/dashboard/dashboard.module').then((m) => m.DashboardModule),
    canActivate: [LoginGuardService],
  },
  {
    path: 'login',
    loadChildren: () => import('./features/login/login.module').then((m) => m.LoginModule)
  },
  {
    path: 'referral',
    loadChildren: () => import('./features/referral/referral.module').then((m) => m.ReferralModule)
  },
  {
    path: 'info',
    loadChildren: () => import('./shared/components/info/info.module').then((m) => m.InfoModule)
  },
  {
    path: 'meter-dashboard/:encryptData', pathMatch: 'prefix',
    loadChildren: () => import('./features/meter-dashboard/meter-dashboard.module').then((m) => m.MeterDashboardModule)
  },
  {
    path: 'meter-dashboard',
    loadChildren: () => import('./features/meter-dashboard/meter-dashboard.module').then((m) => m.MeterDashboardModule),
    canActivate: [AuthGuardService],
  },
  { path: 'docusign-callback/:id', component: ContractCallbackComponent },
  {
    path: '',
    loadChildren: () => import('./features/welcome/welcome.module').then((m) => m.WelcomeModule),
    canActivate: [WelcomeGuardService, PreventLandingGuardService],
  },
  { path: 'error/page-not-found', component: PageNotFoundComponent },
  { path: '**', redirectTo: 'error/page-not-found', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
